var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrganisationTable',{attrs:{"canEdit":true,"editRoute":"SuperAdminClinicEdit","canCreate":true,"createRoute":"SuperAdminClinicCreate","canAssignClinic":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }